import React from "react";
import Grid from "@material-ui/core/Grid";
import SettingsIcon from "@material-ui/icons/Settings";

import useStyles from "./style";

function Empty() {
  const classes = useStyles();
  return (
    <Grid
      item
      container
      direction="column"
      alignItems="center"
      justify="center"
      className={classes.empty}
    >
      <Grid item>
        <SettingsIcon fontSize="large" />
      </Grid>
      <Grid item>No Setting Selected</Grid>
    </Grid>
  );
}

export default Empty;
